import type { RefCallback, MutableRefObject, RefObject } from 'react';

export default (
  ref1:
    | MutableRefObject<HTMLElement | null>
    | RefCallback<HTMLElement>
    | null
    | undefined,
  ref2: RefObject<HTMLElement | null> | null | undefined,
) => {
  if (!ref1 || !ref2) {
    return;
  }

  if (typeof ref1 === 'function') {
    ref1(ref2.current);
  } else if (ref2.current) {
    ref1.current = ref2.current;
  }
};
